import type { TPost } from "./validators";

export function getBookmarkedPosts(): TPost[] {
  const bookmarks = localStorage.getItem("bookmarks");

  if (!bookmarks) {
    return [];
  }

  try {
    return JSON.parse(bookmarks);
  } catch (error) {
    console.error("Error parsing bookmarks from localStorage:", error);
    return [];
  }
}

export function saveBookmarkedPosts(bookmarkedPosts: TPost[]) {
  try {
    localStorage.setItem("bookmarks", JSON.stringify(bookmarkedPosts));
  } catch (error) {
    console.error("Error saving bookmarks to localStorage:", error);
  }
}

export function removeBookmarkedPost(postId: number, bookmarkedPosts: TPost[]) {
  const updatedBookmarks = bookmarkedPosts.filter((post) => post.id !== postId);
  saveBookmarkedPosts(updatedBookmarks);
}
